/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import {firstValueFrom} from 'rxjs';

import {ApiConfig} from '../../app/config/api-config';
import {AdnApiClientService} from '../../app/common/controller/adn-api-client.service';



@Injectable({
  providedIn: 'root'
})
export class AdnAdDensityService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  fetchAll(): Promise<any> {
    return this.send({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['adnaddensity', 'fetchall']),
      params: _.assign({}, {format: 'json', concise: true})
    });
  }

  deleteEntry(add: any): Promise<any> {
    return this.send({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['adnaddensity', 'deleteentry']),
      params: _.assign({}, {format: 'json', concise: true, adDensityId: add.idOfAdDensity})
    });
  }

  takeAdDensity(url: string, bypassSave?: boolean): Promise<any> {
    return this.send({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['adnaddensity', 'takeaddensity']),
      params: _.assign({}, {format: 'json', concise: true, url: url, bypassSave: bypassSave})
    });
  }

  private send(config: any): Promise<any> {
    return firstValueFrom(this.client.request(config));
  }
}
